export const CATEGORY_CODES = {
  accounting: 'ACCOUNTING',
  ein: 'EIN',
  inc: 'INC',
  incStates: 'INC_States',
};
